import slugify from 'slugify'
import { ITableV1Widget, ITabsTableV1Category } from '@/root/types/common'

export const generateDetailUrl = ({
  stock_name,
  company_code,
  link,
  params = '',
}: {
  stock_name: string
  company_code?: string
  params?: string
  link?: string
}) => {
  if (link) {
    return `${link}${params}`
  }
  return stock_name
    ? `/stocks/${slugify(
        stock_name.toLowerCase(),
      )}-share-price/${company_code}${params}`
    : ''
}

export const splitArrayIntoGroups = (arr: unknown[], groupSize: number) => {
  return arr
    .map((value: unknown, index: number) => {
      if (value && index % groupSize === 0) {
        return arr.slice(index, index + groupSize)
      }
      return null
    })
    .filter(Boolean)
}

export const getTableData = (
  widget: ITableV1Widget & ITabsTableV1Category,
  type?: string,
) => {
  if (type === 'table') {
    return {
      title: widget.title,
      heading: widget.data?.heading,
      sub_heading: widget.data?.sub_heading,
      relative_path: widget.data?.relative_path,
      columns: widget.data?.columns,
      rows: widget.data?.rows,
    }
  } else if (type === 'chiclet_table') {
    return {
      heading: widget.heading,
      sub_heading: widget.sub_heading,
      relative_path: widget.relative_path,
      columns: widget.columns,
      rows: widget.rows,
    }
  } else {
    return null
  }
}

export const getFixedFloatValue = (value?: number, length?: number) => {
  if (!value) return 0
  return parseFloat(value.toFixed(length ?? 2))
}

export function getOrdinal(n) {
  let ord = 'th'

  if (n % 10 == 1 && n % 100 != 11) {
    ord = 'st'
  } else if (n % 10 == 2 && n % 100 != 12) {
    ord = 'nd'
  } else if (n % 10 == 3 && n % 100 != 13) {
    ord = 'rd'
  }

  return ord
}
